/* eslint-disable no-unused-vars */
import { LogoutUser } from '@/database/userDatabaseService';
import Filter from './Filters';
import { FilterIcon } from '@/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dispatch } from 'redux';
import { FilterSpec } from '@/redux-store/slices/bookListStore';


interface SideBarProps {
  filterSpec: FilterSpec;
  classes: any;
  lessons:any;
  dispatch: Dispatch<any>;
  setFilter: (filter: FilterSpec) => void;
  resetUserBooks: () => void;
}

const SideBar: React.FC<SideBarProps> = ({
  filterSpec,
  classes,
  lessons,
  dispatch,
  setFilter,
  resetUserBooks,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'filters' });
  const navigate = useNavigate();

  const logout = async () => {
    await LogoutUser();
    navigate('/');
    dispatch(resetUserBooks());
  };

  const onFilter = (type: string, id: number, isChecked: boolean) => {
    if (type === 'status') {
      dispatch(
        setFilter({
          ...filterSpec,
          status: id === 0 ? null : true,
        }),
      );
    } else if (type === 'class') {
      dispatch(
        setFilter({
          ...filterSpec,
          classId: isChecked ? id : 0,
        }),
      );
    } else if (type === 'lesson') {
      dispatch(
        setFilter({
          ...filterSpec,
          lessonId: isChecked ? id : 0,
        }),
      );
    }
  };

  return (
    <>
      <div className="sidebar">
        <div className="filter-area">
          <Filter
            onFilter={onFilter}
            type="class"
            icon={<FilterIcon className={undefined} />}
            options={classes}
            title={t('classes')}
            isSearchable={true}
            searchPlaceHolder={t('classplaceholder')}
            checkedId={filterSpec.classId}
          />
          <Filter
            onFilter={onFilter}
            type="lesson"
            icon={<FilterIcon className={undefined} />}
            options={lessons}
            title={t('branches')}
            isSearchable={true}
            searchPlaceHolder={t('branchplaceholder')}
            checkedId={filterSpec.lessonId}
          />
        </div>
        <div className="sidebar-actions">

          <div className="version">v.2.0</div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
